/* VOROG — LA FORGE DE LA LAME.

   Le monogramme n'est pas un logo posé : c'est une DAGUE, et cette séquence
   est la seule chose du site qui le dise. Cinq temps, tous liés au scroll,
   tous sur la même valeur 0 → 1 :

     LE PLAN     la géométrie de construction se relève — axe de lame, ligne
                 de garde, cercles de tracé, cotes chiffrées qui montent.
     LE TRACÉ    le contour s'écrit LE LONG de ces guides. Le V, puis le K :
                 deux coups de plume sur un seul chemin.
     LE CALAGE   les guides se retirent, et la marque se cale comme une presse
                 qui se règle — cyan et magenta se décalent d'un cheveu puis
                 se superposent. Pas un glitch d'écran : un défaut de repérage
                 d'imprimeur. C'est la langue du site, pas celle d'un jeu.
     LA FORGE    l'encre coule dans la forme derrière un front de braise, du
                 pommeau vers la pointe. Le métal REFROIDIT vers le noir de la
                 marque — sur du papier blanc, le blanc chaud ne se verrait
                 pas ; l'orange, si, et il finit dans l'encre du site. C'est
                 le seul moment coloré de toute la boutique.
     LA POINTE   la lame est faite. Le contour se rétracte dans la pointe, le
                 fil en sort, et il descend jusqu'au bas de la page.

   Sorti du HTML : 2,6 Ko repartaient dans le document à chaque vue de
   l'accueil, alors que c'est lui qui bloque l'analyse en WebView TikTok. En
   fichier différé, pris une fois et gardé. La boucle partagée, elle, reste en
   ligne : elle existe donc déjà quand on s'y enregistre.

   Sans JS, en motion réduit, ou sans la boucle : la marque est pleine, nette,
   immobile. Rien n'attend une animation pour être lisible. */
(function () {
  var NS = 'http://www.w3.org/2000/svg';
  var VB = [99.2316, 79.662, 380.037, 682.5];
  var MX = [1, 0, 0, -1, 343.8436, 578.20706];
  var AXE = VB[0] + VB[2] / 2;

  function el(nom, attrs) {
    var n = document.createElementNS(NS, nom);
    for (var k in attrs) if (attrs.hasOwnProperty(k)) n.setAttribute(k, attrs[k]);
    return n;
  }
  function svg(cls) {
    var s = el('svg', { 'class': 'vorog-hero__mono ' + cls, viewBox: VB.join(' '), focusable: 'false' });
    s.setAttribute('aria-hidden', 'true');
    return s;
  }
  function clamp01(v) { return v < 0 ? 0 : v > 1 ? 1 : v; }
  function courbe(t) { return 0.5 - 0.5 * Math.cos(Math.PI * clamp01(t)); }

  function initHero(root) {
    if (!root || root.dataset.vfhInit) return;
    root.dataset.vfhInit = '1';
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var forge = root.querySelector('[data-vfh-forge]');
    var line = root.querySelector('.vorog-hero__mono--line .vorog-mono__path');
    var relay = root.querySelector('[data-vfh-relay]');
    if (!forge || !line || !relay) return;
    var relaySvg = relay.closest('svg');
    if (!relaySvg) return;
    var hint = root.querySelector('[data-vfh-hint]');

    var lineLen = line.getTotalLength();
    line.style.strokeDasharray = lineLen;
    line.style.strokeDashoffset = lineLen;

    // frontière V→K et pointe de la dague : mesurées sur le tracé réel
    // (une passe de ~200 appels, à l'init uniquement)
    function toUser(pt) { return { x: MX[0] * pt.x + MX[4], y: MX[3] * pt.y + MX[5] }; }
    var vcut = 0.57, tip = null, tipFrac = 0.955, midX = VB[0] + VB[2] * 0.52;
    (function () {
      var lastSide = null, best = { x: AXE, y: VB[1] + VB[3], frac: 0.955 };
      for (var i = 0; i <= 200; i++) {
        var u = toUser(line.getPointAtLength(lineLen * i / 200));
        var side = u.x < midX ? 'V' : 'K';
        if (lastSide === 'V' && side === 'K' && i / 200 > 0.4 && i / 200 < 0.75) vcut = i / 200;
        lastSide = side;
        if (u.y > best.y) best = { x: u.x, y: u.y, frac: i / 200 };
      }
      tip = best;
      tipFrac = best.frac;
    })();

    var uid = (root.id || 'vfh') + '-' + Math.round(tip.y);
    var d = line.getAttribute('d');
    var TR = 'matrix(' + MX.join(',') + ')';

    // ---- LE CHAMP : ça arrive des bords, pas du centre --------------------
    // Le reproche était juste : la marque se construisait dans un carré au
    // milieu d'un écran vide. Ici, l'atelier occupe TOUT l'écran d'abord —
    // des lignes de visée entrent par les quatre bords et se referment sur le
    // point où la lame va naître. Ce n'est qu'une fois refermé que le relevé
    // technique prend la main, à l'échelle de la marque.
    //
    // Le champ vit dans le PANNEAU, pas dans la marque : son repère est en
    // pixels d'écran, refait à chaque changement de taille. C'est la seule
    // façon qu'une ligne touche vraiment le bord, quel que soit l'écran.
    // 91 ecritures de style par frame sur un telephone milieu de gamme, releve
    // par l'audit. Le moteur partage rabat deja les elements « progress » sous
    // 750 px ; le hero, consommateur direct de la boucle, y echappait.
    var petit = window.innerWidth < 750;
    var sticky = root.querySelector('.vorog-hero__sticky');
    var plate = root.querySelector('.vorog-hero__plate') || root;

    /* ÉCRIRE SEULEMENT CE QUI CHANGE.
       Le navigateur ne déduplique pas : reposer la même chaîne sur un attribut
       SVG invalide quand même la géométrie du sous-arbre, et reposer la même
       variable CSS sur un ancêtre invalide le style de toute sa descendance.
       Or la séquence passe l'essentiel de sa course sur des plateaux — le
       champ est refermé dès 28 % et n'en bouge plus, les étincelles sont
       éteintes sur les deux tiers du parcours, la plaque vaut 1 avant 4 % et
       après 78 %. Mesuré : 23 écritures par frame sur le champ dont 16 sur un
       groupe déjà invisible, et 18 (mobile) à 54 (bureau) sur des étincelles
       à opacité zéro. Ces trois fonctions les ramènent à zéro sans changer une
       ligne de la chorégraphie. */
    function attr(e, n, v) { var c = '_a' + n; if (e[c] !== v) { e[c] = v; e.setAttribute(n, v); } }
    function sty(e, n, v) { var c = '_s' + n; if (e[c] !== v) { e[c] = v; e.style[n] = v; } }
    function vari(e, n, v) { var c = '_v' + n; if (e[c] !== v) { e[c] = v; e.style.setProperty(n, v); } }
    var champ = el('svg', { 'class': 'vorog-hero__champ', preserveAspectRatio: 'none', focusable: 'false' });
    champ.setAttribute('aria-hidden', 'true');
    var gRayons = el('g', { 'class': 'vorog-hero__rayons' });
    var gAnneaux = el('g', { 'class': 'vorog-hero__anneaux' });
    var gCoins = el('g', { 'class': 'vorog-hero__coins' });
    var onde = el('circle', { 'class': 'vorog-hero__onde', r: 0 });
    champ.appendChild(gAnneaux);
    champ.appendChild(gRayons);
    champ.appendChild(gCoins);
    champ.appendChild(onde);
    if (sticky) sticky.insertBefore(champ, sticky.firstChild);

    var rayons = [], anneaux = [], coins = [], cx = 0, cy = 0, r0 = 120, loin = 900;
    function poseChamp() {
      if (!sticky) return;
      var sb = sticky.getBoundingClientRect(), fb = forge.getBoundingClientRect();
      var W = Math.round(sb.width), H = Math.round(sb.height);
      if (!W || !H) return;
      champ.setAttribute('viewBox', '0 0 ' + W + ' ' + H);
      // Le point de convergence, c'est le centre de la MARQUE, pas celui de
      // l'écran : la plaque de texte occupe le bas, viser le milieu du panneau
      // ferait converger tout le monde à côté de la lame.
      cx = fb.left - sb.left + fb.width / 2;
      cy = fb.top - sb.top + fb.height / 2;
      r0 = Math.max(70, Math.min(fb.width, fb.height) * 0.6);
      loin = Math.sqrt(W * W + H * H);

      // Sur telephone le champ coute plus qu'il ne rapporte : les rayons sont
      // le poste le plus lourd du releve (une ecriture de dashoffset chacun,
      // a chaque frame). Anneaux et equerres suffisent a habiter l'ecran.
      var n = petit ? 0 : 16, i, a;
      gRayons.textContent = '';
      rayons = [];
      for (i = 0; i < n; i++) {
        a = (i / n) * Math.PI * 2 + 0.19;
        var x1 = cx + Math.cos(a) * loin, y1 = cy + Math.sin(a) * loin;
        var x2 = cx + Math.cos(a) * r0, y2 = cy + Math.sin(a) * r0;
        var l = el('line', { x1: x1.toFixed(1), y1: y1.toFixed(1), x2: x2.toFixed(1), y2: y2.toFixed(1) });
        var len = Math.sqrt((x1 - x2) * (x1 - x2) + (y1 - y2) * (y1 - y2));
        l.style.strokeDasharray = len;
        l.style.strokeDashoffset = len;
        // Décalées : seize lignes qui arrivent d'un seul bloc font un
        // clignotement, pas une convergence.
        rayons.push({ el: l, len: len, ph: (i % 5) / 6 });
        gRayons.appendChild(l);
      }

      gAnneaux.textContent = '';
      anneaux = [];
      for (i = 0; i < 3; i++) {
        var c = el('circle', { cx: cx.toFixed(1), cy: cy.toFixed(1), r: r0 });
        anneaux.push({ el: c, k: 0.34 + i * 0.3 });
        gAnneaux.appendChild(c);
      }

      gCoins.textContent = '';
      coins = [];
      var m = 26, br = Math.min(46, W * 0.07);
      [[m, m, 1, 1], [W - m, m, -1, 1], [m, H - m, 1, -1], [W - m, H - m, -1, -1]].forEach(function (q) {
        var pth = el('path', {
          d: 'M' + q[0] + ' ' + (q[1] + q[3] * br) + 'V' + q[1] + 'H' + (q[0] + q[2] * br)
        });
        coins.push({ el: pth, dx: -q[2], dy: -q[3] });
        gCoins.appendChild(pth);
      });

      onde.setAttribute('cx', cx.toFixed(1));
      onde.setAttribute('cy', cy.toFixed(1));
    }

    // ---- LE PLAN : le releve technique de la lame ------------------------
    // Tout est en coordonnees de la marque, donc tout letterboxe AVEC elle :
    // les guides ne peuvent pas se desaligner du trace.
    var plan = svg('vorog-hero__plan');
    var pg = el('g', { 'class': 'vorog-hero__plan-g' });
    pg.appendChild(el('rect', { x: VB[0], y: VB[1], width: VB[2], height: VB[3], 'stroke-dasharray': '14 11' }));
    pg.appendChild(el('line', { x1: AXE, y1: VB[1] - 46, x2: AXE, y2: VB[1] + VB[3] + 46 }));
    pg.appendChild(el('line', { x1: VB[0] - 40, y1: 420.9, x2: VB[0] + VB[2] + 40, y2: 420.9 }));
    pg.appendChild(el('circle', { cx: AXE, cy: 300, r: 152 }));
    pg.appendChild(el('circle', { cx: AXE, cy: 566, r: 96 }));
    // la cote de hauteur, avec ses deux mouches
    var xc = VB[0] - 26;
    pg.appendChild(el('line', { x1: xc, y1: VB[1], x2: xc, y2: VB[1] + VB[3], 'class': 'vorog-hero__cote-l' }));
    pg.appendChild(el('line', { x1: xc - 9, y1: VB[1], x2: xc + 9, y2: VB[1], 'class': 'vorog-hero__cote-l' }));
    pg.appendChild(el('line', { x1: xc - 9, y1: VB[1] + VB[3], x2: xc + 9, y2: VB[1] + VB[3], 'class': 'vorog-hero__cote-l' }));
    // et l'angle de la pointe : deux traits qui l'encadrent
    pg.appendChild(el('line', { x1: tip.x - 62, y1: tip.y - 96, x2: tip.x, y2: tip.y }));
    pg.appendChild(el('line', { x1: tip.x + 62, y1: tip.y - 96, x2: tip.x, y2: tip.y }));
    plan.appendChild(pg);

    var coteH = el('text', { 'class': 'vorog-hero__cote', x: xc - 16, y: 420.9, transform: 'rotate(-90 ' + (xc - 16) + ' 420.9)', 'text-anchor': 'middle' });
    var coteL = el('text', { 'class': 'vorog-hero__cote', x: AXE, y: VB[1] + VB[3] + 40, 'text-anchor': 'middle' });
    var repere = el('text', { 'class': 'vorog-hero__repere', x: AXE, y: VB[1] + VB[3] + 40, 'text-anchor': 'middle' });
    repere.textContent = 'VK-01 · 380 × 682,5';
    plan.appendChild(coteH);
    plan.appendChild(coteL);
    plan.appendChild(repere);

    // ---- LE CALAGE : deux plaques qui se superposent ---------------------
    var cale = svg('vorog-hero__cale');
    var cyan = el('path', { d: d, transform: TR, 'class': 'vorog-hero__plaque vorog-hero__plaque--c' });
    var mag = el('path', { d: d, transform: TR, 'class': 'vorog-hero__plaque vorog-hero__plaque--m' });
    cale.appendChild(cyan);
    cale.appendChild(mag);

    // ---- LA FORGE : l'encre coule derrière un front de braise -------------
    var braise = svg('vorog-hero__braise');
    var defs = el('defs', {});
    var cpid = 'vfh-c-' + uid, gid = 'vfh-g-' + uid;
    var cp = el('clipPath', { id: cpid });
    cp.appendChild(el('path', { d: d, transform: TR }));
    var grad = el('linearGradient', { id: gid, gradientUnits: 'userSpaceOnUse', x1: 0, x2: 0, y1: 0, y2: 1 });
    [['0', '#0F0F0F', 1], ['0.80', '#0F0F0F', 1], ['0.90', '#7C2D12', 1],
     ['0.955', '#EA580C', 1], ['0.985', '#FDBA74', 1], ['1', '#FDBA74', 0]]
      .forEach(function (s) {
        grad.appendChild(el('stop', { offset: s[0], 'stop-color': s[1], 'stop-opacity': s[2] }));
      });
    defs.appendChild(cp);
    defs.appendChild(grad);
    braise.appendChild(defs);
    var coule = el('rect', { x: VB[0] - 30, y: VB[1] - 60, width: VB[2] + 60, height: VB[3] + 120, 'clip-path': 'url(#' + cpid + ')', fill: 'url(#' + gid + ')' });
    braise.appendChild(coule);

    // Les etincelles suivent le front, elles ne partent pas au hasard.
    var etinc = el('g', { 'class': 'vorog-hero__etincelles' }), lucioles = [];
    for (var i = 0; i < (petit ? 6 : 18); i++) {
      var t = 9 + (i % 4) * 4;
      var r = el('rect', { width: t, height: t });
      etinc.appendChild(r);
      lucioles.push({ el: r, dx: ((i % 6) - 2.5) * 34 + (i % 3) * 11, chute: 60 + (i % 5) * 40, ph: (i * 0.137) % 1, deriv: ((i % 7) - 3) * 16 });
    }
    braise.appendChild(etinc);

    // Ordre de pile : plan, calage, coulee. Le trait et le plein sont deja
    // dans le HTML, ils restent au-dessus.
    forge.insertBefore(plan, forge.firstChild);
    forge.insertBefore(cale, forge.firstChild.nextSibling);
    forge.appendChild(braise);

    // ---- le relais : la verticale de la pointe au bas du hero -------------
    var relayLen = 0;
    function layoutRelay() {
      var box = relaySvg.getBoundingClientRect();
      if (!box.height) return;
      var scale = Math.min(box.width / VB[2], box.height / VB[3]);
      if (!scale) return;
      var tipScreenY = box.top + (box.height - VB[3] * scale) / 2 + (tip.y - VB[1]) * scale;
      var heroBottom = root.getBoundingClientRect().bottom;
      // Jusqu'au bas du hero : c'est LÀ que le fil de page la reprend.
      var localLen = Math.max(40, (heroBottom - tipScreenY) / scale);
      relay.setAttribute('d', 'M' + tip.x.toFixed(1) + ' ' + tip.y.toFixed(1) + ' L' + tip.x.toFixed(1) + ' ' + (tip.y + localLen).toFixed(1));
      relayLen = relay.getTotalLength();
      relay.style.strokeDasharray = relayLen;
      relay.style.strokeDashoffset = relayLen;
      // L'abscisse de la pointe est publiée : le fil de page reprend la
      // descente exactement dans son axe, à la sortie du hero.
      var tipScreenX = box.left + (box.width - VB[2] * scale) / 2 + (tip.x - VB[0]) * scale;
      var de = document.documentElement.style;
      de.setProperty('--vfil-x', Math.round(tipScreenX + window.pageXOffset) + 'px');
      // offsetTop/offsetHeight, pas le rectangle : la course longue du hero
      // n'est posée qu'APRÈS ce premier passage, et le rectangle renvoyait
      // alors la hauteur d'un seul écran.
      de.setProperty('--vfil-top', Math.round(root.offsetTop + root.offsetHeight) + 'px');
      var w = parseFloat(getComputedStyle(relay).strokeWidth) || 5;
      de.setProperty('--vfil-w', (w * scale).toFixed(2));

      // LE PLAN SE MESURE EN PIXELS D'ECRAN. Le SVG letterboxe : sur un
      // portable, une cote de 21 unites tombait a 7 px et le filet sous le
      // demi-pixel. On publie l'inverse de l'echelle.
      forge.style.setProperty('--vfh-cote', (13 / scale).toFixed(1) + 'px');
      forge.style.setProperty('--vfh-hair', (1.15 / scale).toFixed(2) + 'px');
      poseChamp();
    }
    layoutRelay();
    // Le relevé refait toute la géométrie du champ : dix à seize lignes, trois
    // anneaux, quatre équerres. Sans attente, un redimensionnement continu le
    // rejoue à chaque pixel. Deux cent cinquante millisecondes, comme le fil.
    var tRelay = null;
    window.addEventListener('resize', function () {
      clearTimeout(tRelay);
      tRelay = setTimeout(layoutRelay, 250);
    }, { passive: true });

    root.classList.add('vorog-hero--anim');
    document.documentElement.classList.add('vfh-forge');
    layoutRelay();

    function progress() {
      var rect = root.getBoundingClientRect();
      var range = rect.height - window.innerHeight;
      return range > 0 ? clamp01(-rect.top / range) : 0;
    }

    /* L'OUVERTURE NE SE JOUE PLUS TOUTE SEULE. Un essai d'allumage
       automatique (plancher temporel jusqu'au tracé complet) a été posé puis
       retiré : l'écran d'arrivée est désormais une INVITATION — « scroll
       vers le bas », en grand, au centre — et c'est le premier geste qui
       déclenche tout. La séquence reste entièrement au scroll, comme à
       l'origine, mais l'écran d'attente n'est plus vide : il demande. */
    var pCur = null;
    function draw() {
      // Inertie de scroll. À 0,16 la marque suivait le doigt ; à 0,10 elle
      // TRAÎNE derrière lui, et c'est ce retard qui donne la masse. Une lame
      // qu'on forge n'obéit pas au geste, elle lui résiste un peu.
      var cible = progress();
      if (pCur === null) pCur = cible;
      pCur += (cible - pCur) * 0.1;
      var busy = Math.abs(cible - pCur) > 0.0008;
      if (!busy) pCur = cible;
      var p = pCur;

      // 0. LE CHAMP — les lignes de visée entrent par les bords et se
      //    referment. Elles ne disparaissent pas tout à fait : anneaux et
      //    équerres restent en très faible encre jusqu'au bout, sinon l'écran
      //    redevient la page blanche dont on voulait sortir.
      var ferme = courbe(p / 0.18);
      var parti = courbe((p - 0.17) / 0.11);
      var k, o;
      for (k = 0; k < rayons.length; k++) {
        o = rayons[k];
        var t = clamp01((ferme - o.ph) / (1 - o.ph));
        sty(o.el, 'strokeDashoffset', (o.len * (1 - t)).toFixed(1));
      }
      sty(gRayons, 'opacity', (1 - parti).toFixed(3));
      for (k = 0; k < anneaux.length; k++) {
        o = anneaux[k];
        attr(o.el, 'r', (r0 + (1 - ferme) * loin * o.k).toFixed(1));
      }
      sty(gAnneaux, 'opacity', (0.1 + (1 - parti) * 0.9).toFixed(3));
      var recul = (1 - ferme) * 26;
      for (k = 0; k < coins.length; k++) {
        o = coins[k];
        attr(o.el, 'transform', 'translate(' + (o.dx * recul).toFixed(1) + ',' + (o.dy * recul).toFixed(1) + ')');
      }
      sty(gCoins, 'opacity', (0.16 + ferme * 0.5 - parti * 0.5).toFixed(3));

      // L'ONDE : au moment où la lame est faite, le champ repart vers le
      //    dehors. Outil rendu, atelier rendu — et le blanc reprend l'écran
      //    parce qu'on vient de l'en chasser, pas parce qu'il n'y avait rien.
      var choc = courbe((p - 0.72) / 0.17);
      if (choc > 0.001 && choc < 0.999) {
        attr(onde, 'r', (r0 + choc * loin * 0.85).toFixed(1));
        sty(onde, 'opacity', ((1 - choc) * 0.5).toFixed(3));
      } else {
        sty(onde, 'opacity', '0');
      }

      // 1. LE PLAN — il se lève APRÈS que l'invitation a commencé à partir
      //    (0,06, pas 0,02) : les deux occupaient le même centre d'écran.
      var vuePlan = courbe((p - 0.06) / 0.10) * (1 - courbe((p - 0.40) / 0.12));
      sty(plan, 'opacity', vuePlan.toFixed(3));
      if (vuePlan > 0.004) {
        var m = courbe((p - 0.06) / 0.16);
        var cH = (682.5 * m).toFixed(1).replace('.', ',');
        var cL = (380 * m).toFixed(1).replace('.', ',');
        if (coteH._t !== cH) { coteH._t = cH; coteH.textContent = cH; }
        if (coteL._t !== cL) { coteL._t = cL; coteL.textContent = cL; }
      }

      // 2. LE TRACÉ — le V, puis le K, sur le même chemin. Il ne part qu'à
      //    0,10 : l'invitation doit avoir quitté le centre avant que la
      //    plume s'y pose. Le K finit à 0,37, un cheveu avant le calage.
      var ecrit = courbe((p - 0.10) / 0.17) * vcut + courbe((p - 0.24) / 0.13) * (1 - vcut);

      // 3. LE CALAGE — les cotes s'effondrent en une référence, et la presse
      //    se règle : l'écart des plaques tombe à zéro.
      var vueRep = courbe((p - 0.42) / 0.07) * (1 - courbe((p - 0.88) / 0.09));
      sty(repere, 'opacity', vueRep.toFixed(3));
      var ecart = (1 - courbe((p - 0.42) / 0.11)) * courbe((p - 0.38) / 0.04) * 11;
      sty(cale, 'opacity', ecart > 0.06 ? '1' : '0');
      attr(cyan, 'transform', 'translate(' + (-ecart).toFixed(2) + ',' + (ecart * 0.35).toFixed(2) + ') ' + TR);
      attr(mag, 'transform', 'translate(' + ecart.toFixed(2) + ',' + (-ecart * 0.35).toFixed(2) + ') ' + TR);

      // 4. LA FORGE — le front descend du pommeau a la pointe : au-dessus
      //    l'encre est prise, au-dessous il n'y a encore rien.
      var coulee = courbe((p - 0.50) / 0.26);
      var front = VB[1] - 40 + coulee * (tip.y - VB[1] + 90);
      attr(grad, 'y1', (front - 300).toFixed(1));
      attr(grad, 'y2', (front + 18).toFixed(1));
      var chaud = coulee > 0.001 && coulee < 0.999;
      // La braise s'éteint AVANT que la plaque s'écrive (0,82) : un reste de
      // marque grise derrière le titre en train de naître, relevé à l'écran,
      // c'était le pire moment pour cohabiter.
      sty(braise, 'opacity', coulee > 0.001 ? (1 - courbe((p - 0.80) / 0.10)).toFixed(3) : '0');
      // Étincelles : hors de la coulée on ne les repositionne même plus. Le
      // groupe sort du rendu d'un seul accès, au lieu de trois écritures par
      // étincelle et par frame pour reposer les mêmes zéros.
      if (chaud) {
        sty(etinc, 'display', '');
        for (var k = 0; k < lucioles.length; k++) {
          var l = lucioles[k];
          var t = ((coulee * 3.6) + l.ph) % 1;
          attr(l.el, 'x', (AXE + l.dx + l.deriv * t).toFixed(1));
          attr(l.el, 'y', (front + t * l.chute).toFixed(1));
          attr(l.el, 'opacity', ((1 - t) * 0.85).toFixed(2));
        }
      } else {
        sty(etinc, 'display', 'none');
      }

      // 5. LE PLEIN prend le relais de la coulée, puis LA POINTE. Il meurt
      //    dès que la plaque commence à s'écrire (0,82) : le trait quitte la
      //    marque pour aller écrire le titre — pas de fantôme gris derrière.
      var plein = courbe((p - 0.72) / 0.06) * (1 - courbe((p - 0.82) / 0.06));
      vari(forge, '--vfh-fill', plein.toFixed(3));

      // LA PLAQUE : PRÉSENTE, PUIS RETIRÉE, PUIS RÉÉCRITE PAR LE TRAIT.
      //
      // Première version : elle naissait du trait, donc elle était découpée à
      // ZÉRO tant qu'on n'avait pas fait défiler. Un audit l'a relevé, et il a
      // raison : le visiteur qui arrive de TikTok atterrissait sur une grille
      // de points, sans titre, sans accroche et sans bouton d'achat. Le
      // premier écran d'une boutique ne peut pas être vide.
      //
      // Elle est donc là au chargement, entière. Le trait l'efface quand la
      // séquence démarre — la marque se construit seule, c'était la demande —
      // puis la réécrit une fois la lame forgée. Trois temps, une variable.
      //
      // La variable est posée sur la PLAQUE, plus sur la section : elle n'a
      // qu'un consommateur, et l'écrire sur la racine invalidait le style de
      // tout le sous-arbre — titre découpé en spans, accroche, boutons — à
      // chaque frame de défilement.
      // LE MÊME TRAIT FAIT LES DEUX. `pointe` est la phase où la ligne du
      // monogramme s'efface par la queue pendant que sa pointe avance : le
      // trait emporte la marque. C'est EXACTEMENT cette valeur qui écrit
      // maintenant la plaque, au lieu d'une plage à part calée sur 0,56.
      //
      // La différence n'est pas un réglage, c'est une causalité : avant, le
      // titre revenait pendant que le monogramme était encore entier — deux
      // choses qui arrivaient en même temps sans rapport l'une avec l'autre.
      // Maintenant le trait quitte le monogramme et va écrire le titre. Une
      // seule valeur, donc un seul geste, et on ne peut plus les désaccorder.
      var pointe = courbe((p - 0.82) / 0.18);

      // LA PLAQUE N'EXISTE QUE PAR LE TRAIT. Elle était présente au
      // chargement puis effacée par le début de séquence — donc elle
      // cohabitait avec la formation du monogramme, et c'est exactement ce
      // qu'on ne voulait pas : deux choses qui se construisent en même temps,
      // dont l'une parasite l'autre. Une seule valeur, une seule cause.
      //
      // CE QUE ÇA COÛTE, ET C'EST ASSUMÉ : le visiteur qui arrive voit le
      // monogramme se former, pas le titre. Le h1 reste dans le document —
      // `clip-path` découpe le rendu, pas le contenu — donc l'indexation et
      // les lecteurs d'écran n'y perdent rien. C'est l'œil qui attend.
      vari(plate, '--vfh-plaque', pointe.toFixed(3));

      if (p >= 0.80) {
        var tipL = lineLen * tipFrac;
        var k2 = tipL * pointe;
        sty(line, 'strokeDasharray', Math.max(0.01, tipL - k2) + ' ' + (lineLen * 2));
        sty(line, 'strokeDashoffset', (-k2).toFixed(1));
      } else {
        sty(line, 'strokeDasharray', String(lineLen));
        sty(line, 'strokeDashoffset', (lineLen * (1 - ecrit)).toFixed(1));
      }
      if (relayLen) sty(relay, 'strokeDashoffset', (relayLen * (1 - pointe)).toFixed(1));

      // Largeur 5 -> 4 px, avec une pulsation pendant la coulee : le metal ne
      // se pose pas d'un coup, il respire en refroidissant.
      var w = 5 - clamp01((p - 0.88) / 0.10);
      if (p > 0.50 && p < 0.78) w += Math.sin((p - 0.50) * 52) * 0.2;
      vari(forge, '--vfh-w', w.toFixed(2));

      // L'INVITATION : le trait l'emporte vers le haut sur le premier dixième
      // de la course, pendant que les lignes de visée convergent sur la place
      // qu'elle libère. Une variable, un consommateur, écriture dédupliquée.
      if (hint) vari(hint, '--vfh-invite', courbe(p / 0.10).toFixed(3));

      // LE SON DE LA SÉQUENCE, s'il est allumé. Trois évènements sur trois
      // écrans de défilement : le soufflet quand l'encre part, l'enclume quand
      // la lame est faite, la raclée du trait quand le titre s'écrit. Chacun
      // est armé une seule fois et se réarme si on remonte — sinon un
      // va-et-vient au milieu de la course déclencherait le même coup vingt
      // fois de suite.
      if (window.VorogSon) {
        // La scène : chaque frame publie sa progression. C'est elle qui
        // donne à la musique le droit d'entrer quand la plaque s'écrit.
        if (window.VorogSon.scene) window.VorogSon.scene(p);
        // La bande-son électronique de la forge : chaque phase a son geste
        // machine. Balayage d'air, SCAN quand les visées se referment, la
        // COMPILATION pendant que la plume écrit, le GLITCH au calage
        // cyan/magenta (c'en est un), la MONTÉE sous l'onde. Chacun s'arme
        // une fois et se réarme si on remonte — comme les trois d'origine.
        if (!root._vfhD && p > 0.06) { root._vfhD = 1; window.VorogSon.jouer('balaye'); }
        if (root._vfhD && p < 0.02) root._vfhD = 0;
        if (!root._vfhE && p > 0.14) { root._vfhE = 1; window.VorogSon.jouer('scan'); }
        if (root._vfhE && p < 0.09) root._vfhE = 0;
        if (!root._vfhF && p > 0.30) { root._vfhF = 1; window.VorogSon.jouer('code'); }
        if (root._vfhF && p < 0.24) root._vfhF = 0;
        if (!root._vfhG && p > 0.44) { root._vfhG = 1; window.VorogSon.jouer('glitch'); }
        if (root._vfhG && p < 0.38) root._vfhG = 0;
        // L'onde reste MUETTE, et c'est voulu : le power-up essayé ici
        // sonnait comme un réacteur au décollage. Le silence entre la
        // coulée et le drop, c'est ce qui fait tomber le drop.
        if (!root._vfhA && coulee > 0.02) { root._vfhA = 1; window.VorogSon.jouer('souffle'); }
        if (root._vfhA && coulee < 0.005) root._vfhA = 0;
        if (!root._vfhB && coulee > 0.985) { root._vfhB = 1; window.VorogSon.jouer('lame'); }
        if (root._vfhB && coulee < 0.5) root._vfhB = 0;
        if (!root._vfhC && p > 0.6) { root._vfhC = 1; window.VorogSon.jouer('trait'); }
        if (root._vfhC && p < 0.55) root._vfhC = 0;
      }
      return busy;
    }

    draw();
    if (window.VorogMotion && window.VorogMotion.register) {
      window.VorogMotion.register({
        active: function () {
          var r = root.getBoundingClientRect();
          return r.bottom > 0 && r.top < window.innerHeight;
        },
        update: draw
      });
    } else {
      // pas de boucle partagée : monogramme plein, statique
      document.documentElement.classList.remove('vfh-forge');
    }
  }

  initHero(document.querySelector('[data-vorog-hero]'));
  document.addEventListener('shopify:section:load', function (e) {
    var r = e.target && e.target.querySelector ? e.target.querySelector('[data-vorog-hero]') : null;
    if (r) initHero(r);
  });
})();
